export default __webpack_public_path__ + "static/media/toyshelves.6e4063ea.png";